// Phase 40.13 — Exam-specific colour skins.
// Each competitive exam maps to one of 13 category palettes so the detail
// hero, mode-selection cards, Real Exam / Quick Answer / Mock / Lab headers
// all feel like they belong to that exam's "test lounge".

// Palette shape: Tailwind class fragments so consumers can compose them.
const PALETTES = {
  engineering: {
    id: 'engineering',
    label: 'Engineering',
    heroFrom: 'from-orange-500',
    heroTo: 'to-red-600',
    heroBg: 'from-orange-50 to-red-50 dark:from-orange-950/25 dark:to-red-950/25',
    accent: 'text-orange-600 dark:text-orange-400',
    ring: 'ring-orange-400/60',
    chip: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
    modeBorder: 'border-orange-200 dark:border-orange-800 hover:border-orange-400',
    iconBg: 'bg-orange-100 dark:bg-orange-900/30',
    iconFg: 'text-orange-600 dark:text-orange-400',
  },
  medical: {
    id: 'medical',
    label: 'Medical',
    heroFrom: 'from-emerald-500',
    heroTo: 'to-green-600',
    heroBg: 'from-emerald-50 to-green-50 dark:from-emerald-950/25 dark:to-green-950/25',
    accent: 'text-emerald-600 dark:text-emerald-400',
    ring: 'ring-emerald-400/60',
    chip: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400',
    modeBorder: 'border-emerald-200 dark:border-emerald-800 hover:border-emerald-400',
    iconBg: 'bg-emerald-100 dark:bg-emerald-900/30',
    iconFg: 'text-emerald-600 dark:text-emerald-400',
  },
  law: {
    id: 'law',
    label: 'Law',
    heroFrom: 'from-violet-500',
    heroTo: 'to-purple-600',
    heroBg: 'from-violet-50 to-purple-50 dark:from-violet-950/25 dark:to-purple-950/25',
    accent: 'text-violet-600 dark:text-violet-400',
    ring: 'ring-violet-400/60',
    chip: 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400',
    modeBorder: 'border-violet-200 dark:border-violet-800 hover:border-violet-400',
    iconBg: 'bg-violet-100 dark:bg-violet-900/30',
    iconFg: 'text-violet-600 dark:text-violet-400',
  },
  defence: {
    id: 'defence',
    label: 'Defence',
    heroFrom: 'from-indigo-600',
    heroTo: 'to-blue-800',
    heroBg: 'from-indigo-50 to-blue-50 dark:from-indigo-950/25 dark:to-blue-950/25',
    accent: 'text-indigo-600 dark:text-indigo-400',
    ring: 'ring-indigo-400/60',
    chip: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400',
    modeBorder: 'border-indigo-200 dark:border-indigo-800 hover:border-indigo-400',
    iconBg: 'bg-indigo-100 dark:bg-indigo-900/30',
    iconFg: 'text-indigo-600 dark:text-indigo-400',
  },
  civil: {
    id: 'civil',
    label: 'Civil Services',
    heroFrom: 'from-amber-500',
    heroTo: 'to-yellow-600',
    heroBg: 'from-amber-50 to-yellow-50 dark:from-amber-950/25 dark:to-yellow-950/25',
    accent: 'text-amber-600 dark:text-amber-400',
    ring: 'ring-amber-400/60',
    chip: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
    modeBorder: 'border-amber-200 dark:border-amber-800 hover:border-amber-400',
    iconBg: 'bg-amber-100 dark:bg-amber-900/30',
    iconFg: 'text-amber-600 dark:text-amber-400',
  },
  banking: {
    id: 'banking',
    label: 'Banking',
    heroFrom: 'from-blue-500',
    heroTo: 'to-cyan-600',
    heroBg: 'from-blue-50 to-cyan-50 dark:from-blue-950/25 dark:to-cyan-950/25',
    accent: 'text-blue-600 dark:text-blue-400',
    ring: 'ring-blue-400/60',
    chip: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
    modeBorder: 'border-blue-200 dark:border-blue-800 hover:border-blue-400',
    iconBg: 'bg-blue-100 dark:bg-blue-900/30',
    iconFg: 'text-blue-600 dark:text-blue-400',
  },
  management: {
    id: 'management',
    label: 'Management',
    heroFrom: 'from-rose-500',
    heroTo: 'to-pink-600',
    heroBg: 'from-rose-50 to-pink-50 dark:from-rose-950/25 dark:to-pink-950/25',
    accent: 'text-rose-600 dark:text-rose-400',
    ring: 'ring-rose-400/60',
    chip: 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400',
    modeBorder: 'border-rose-200 dark:border-rose-800 hover:border-rose-400',
    iconBg: 'bg-rose-100 dark:bg-rose-900/30',
    iconFg: 'text-rose-600 dark:text-rose-400',
  },
  ssc_railway: {
    id: 'ssc_railway',
    label: 'SSC / Railway',
    heroFrom: 'from-teal-500',
    heroTo: 'to-cyan-600',
    heroBg: 'from-teal-50 to-cyan-50 dark:from-teal-950/25 dark:to-cyan-950/25',
    accent: 'text-teal-600 dark:text-teal-400',
    ring: 'ring-teal-400/60',
    chip: 'bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-400',
    modeBorder: 'border-teal-200 dark:border-teal-800 hover:border-teal-400',
    iconBg: 'bg-teal-100 dark:bg-teal-900/30',
    iconFg: 'text-teal-600 dark:text-teal-400',
  },
  commerce: {
    id: 'commerce',
    label: 'Commerce',
    heroFrom: 'from-yellow-500',
    heroTo: 'to-amber-600',
    heroBg: 'from-yellow-50 to-amber-50 dark:from-yellow-950/25 dark:to-amber-950/25',
    accent: 'text-yellow-600 dark:text-yellow-500',
    ring: 'ring-yellow-400/60',
    chip: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
    modeBorder: 'border-yellow-200 dark:border-yellow-800 hover:border-yellow-400',
    iconBg: 'bg-yellow-100 dark:bg-yellow-900/30',
    iconFg: 'text-yellow-600 dark:text-yellow-500',
  },
  design: {
    id: 'design',
    label: 'Design',
    heroFrom: 'from-fuchsia-500',
    heroTo: 'to-pink-600',
    heroBg: 'from-fuchsia-50 to-pink-50 dark:from-fuchsia-950/25 dark:to-pink-950/25',
    accent: 'text-fuchsia-600 dark:text-fuchsia-400',
    ring: 'ring-fuchsia-400/60',
    chip: 'bg-fuchsia-100 text-fuchsia-700 dark:bg-fuchsia-900/30 dark:text-fuchsia-400',
    modeBorder: 'border-fuchsia-200 dark:border-fuchsia-800 hover:border-fuchsia-400',
    iconBg: 'bg-fuchsia-100 dark:bg-fuchsia-900/30',
    iconFg: 'text-fuchsia-600 dark:text-fuchsia-400',
  },
  olympiad: {
    id: 'olympiad',
    label: 'Olympiad',
    heroFrom: 'from-cyan-500',
    heroTo: 'to-sky-600',
    heroBg: 'from-cyan-50 to-sky-50 dark:from-cyan-950/25 dark:to-sky-950/25',
    accent: 'text-cyan-600 dark:text-cyan-400',
    ring: 'ring-cyan-400/60',
    chip: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400',
    modeBorder: 'border-cyan-200 dark:border-cyan-800 hover:border-cyan-400',
    iconBg: 'bg-cyan-100 dark:bg-cyan-900/30',
    iconFg: 'text-cyan-600 dark:text-cyan-400',
  },
  school: {
    id: 'school',
    label: 'School Scholarship',
    heroFrom: 'from-sky-500',
    heroTo: 'to-blue-600',
    heroBg: 'from-sky-50 to-blue-50 dark:from-sky-950/25 dark:to-blue-950/25',
    accent: 'text-sky-600 dark:text-sky-400',
    ring: 'ring-sky-400/60',
    chip: 'bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-400',
    modeBorder: 'border-sky-200 dark:border-sky-800 hover:border-sky-400',
    iconBg: 'bg-sky-100 dark:bg-sky-900/30',
    iconFg: 'text-sky-600 dark:text-sky-400',
  },
  teacher: {
    id: 'teacher',
    label: 'Teaching',
    heroFrom: 'from-lime-500',
    heroTo: 'to-green-600',
    heroBg: 'from-lime-50 to-green-50 dark:from-lime-950/25 dark:to-green-950/25',
    accent: 'text-lime-600 dark:text-lime-400',
    ring: 'ring-lime-400/60',
    chip: 'bg-lime-100 text-lime-700 dark:bg-lime-900/30 dark:text-lime-400',
    modeBorder: 'border-lime-200 dark:border-lime-800 hover:border-lime-400',
    iconBg: 'bg-lime-100 dark:bg-lime-900/30',
    iconFg: 'text-lime-600 dark:text-lime-400',
  },
  default: {
    id: 'default',
    label: 'General',
    heroFrom: 'from-violet-500',
    heroTo: 'to-indigo-600',
    heroBg: 'from-violet-50 to-indigo-50 dark:from-violet-950/25 dark:to-indigo-950/25',
    accent: 'text-violet-600 dark:text-violet-400',
    ring: 'ring-violet-400/60',
    chip: 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400',
    modeBorder: 'border-violet-200 dark:border-violet-800 hover:border-violet-400',
    iconBg: 'bg-violet-100 dark:bg-violet-900/30',
    iconFg: 'text-violet-600 dark:text-violet-400',
  },
};

// exam_id → palette key.  Keys mirror /api/competitive-exams exam_ids.
const EXAM_TO_PALETTE = {
  // Engineering
  jee_main: 'engineering', jee_advanced: 'engineering', bitsat: 'engineering',
  viteee: 'engineering', srmjeee: 'engineering', wbjee: 'engineering',
  mht_cet: 'engineering', ap_eamcet: 'engineering', ts_eamcet: 'engineering',
  kcet: 'engineering', gate: 'engineering', nata: 'engineering',
  // Medical
  neet_ug: 'medical', neet_pg: 'medical', aiims_nursing: 'medical',
  jipmer: 'medical', icar_aieea: 'medical',
  // Law
  clat: 'law', ailet: 'law', lsat_india: 'law', clat_pg: 'law',
  // Defence
  upsc_nda: 'defence', cds: 'defence', afcat: 'defence', upsc_capf: 'defence',
  // Civil Services
  upsc_cse: 'civil', state_pcs: 'civil',
  // Banking
  ibps_po: 'banking', ibps_clerk: 'banking', sbi_po: 'banking', rbi_grade_b: 'banking',
  // Management
  cat: 'management', xat: 'management', mat: 'management',
  // SSC / Railway
  ssc_cgl: 'ssc_railway', ssc_chsl: 'ssc_railway', ssc_mts: 'ssc_railway',
  railway_ntpc: 'ssc_railway', railway_group_d: 'ssc_railway',
  // Commerce
  ca_foundation: 'commerce', cs_foundation: 'commerce',
  // Design
  nid_dat: 'design', uceed: 'design',
  // Olympiads / research
  olympiad_math: 'olympiad', olympiad_science: 'olympiad',
  kvpy: 'olympiad', nest: 'olympiad', iat: 'olympiad', cuet_ug: 'olympiad',
  // School scholarship
  ntse: 'school', sainik_school: 'school', jnvst: 'school',
  // Teaching
  ctet: 'teacher', tet: 'teacher',
};

// Fallback: derive palette from the exam's `category` field when the exam_id
// isn't explicitly mapped (keeps us safe as new exams are added upstream).
const CATEGORY_TO_PALETTE = {
  engineering: 'engineering',
  medical: 'medical',
  law: 'law',
  defence: 'defence',
  civil_services: 'civil',
  banking: 'banking',
  management: 'management',
  ssc_railway: 'ssc_railway',
  commerce: 'commerce',
  design: 'design',
  research: 'olympiad',
  scholarship: 'school',
  teaching: 'teacher',
};

export function getExamPalette(examOrId, category) {
  const id = typeof examOrId === 'string' ? examOrId : examOrId?.exam_id;
  const cat = category || (typeof examOrId === 'object' ? examOrId?.category : null);
  const paletteKey = EXAM_TO_PALETTE[id] || CATEGORY_TO_PALETTE[cat] || 'default';
  return PALETTES[paletteKey] || PALETTES.default;
}

export const EXAM_PALETTES = PALETTES;
